import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputBenutzerSyncOptionAddModifyRelation } from './InputBenutzerSyncOptionAddModifyRelation.entity';

export class InputBenutzerSyncOptionsRelation<T extends EMode = EMode.entity> {
  /** Alias: addModify */
  addModify?: InputBenutzerSyncOptionAddModifyRelation<T>[];
  /** Alias: remove */
  remove?: string[];

  __typename?: string;
}

const fields: FieldDefinitions<InputBenutzerSyncOptionsRelation> = {
  addModify: {
    alias: 'addModify',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputBenutzerSyncOptionsRelationEntityDefinition: EntitiyDefinition<InputBenutzerSyncOptionsRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputBenutzerSyncOptionsRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
